interface PanelNoticeProps {
  /** Why nothing can be decided now, or null. */
  lockedReason: string | null;
  canDecide: boolean;
  /** The server's last refusal of a one-click decision, shown where the closer is looking. */
  refusal: string | null;
}

/** The line under the heading saying why the buttons are missing, or why the last click was refused. */
export function PanelNotice({ lockedReason, canDecide, refusal }: PanelNoticeProps) {
  const reason = lockedReason ?? (canDecide ? null : 'You can see these but not decide them.');
  return (
    <>
      {reason && <p className="text-sm text-muted">{reason}</p>}
      {refusal && (
        <p role="alert" className="text-sm text-error">
          {refusal}
        </p>
      )}
    </>
  );
}
